import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import { SectionDivider } from '../../components/shared/dividers/SectionDivider';

Builder.registerComponent(SectionDivider, {
    name: BUILDER_DIVIDER_NAMES.SectionDivider,
});
